<template>
  <v-row>
    <v-col cols="12" :md="modalView ? 12 : 6" :offset-md="modalView ? 0 : 3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime grupe *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
          :items="taxTypes"
          item-text="name"
          item-value="id"
          v-model="form.tax_type"
          label="Tip davka *"
        ></v-select>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.tax_type.required)"
        >
          <FormErrorsLine v-if="!$v.form.tax_type.required" text="Polje je obvezno" />
        </FormErrors>
        <v-select
          :items="taxLevels"
          :item-text="taxLevelsItemText"
          item-value="id"
          v-model="form.tax_level"
          label="Stopnja davka *"
        ></v-select>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.tax_level.required)"
        >
          <FormErrorsLine v-if="!$v.form.tax_level.required" text="Polje je obvezno" />
        </FormErrors>
        <v-text-field
          v-model="form.tax_description"
          label="Opis davka"
        ></v-text-field>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    group: {
      default: () => {},
      type: Object
    },
    taxTypes: {
      required: true,
      type: Array
    },
    taxLevels: {
      required: true,
      type: Array
    },
    modalView: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      form: {
        name: null,
        tax_type: null,
        tax_level: null,
        tax_description: null
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      tax_type: {
        required
      },
      tax_level: {
        required
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    taxLevelsItemText (item) {
      return `${item.value}%`
    },
    cancel () {
      if (this.modalView) {
        this.$emit('cancel')
      } else {
        this.$router.go(-1)
      }
    },
    clearForm () {
      this.form = {
        name: null,
        tax_type: null,
        tax_level: null,
        tax_description: null
      }
      this.$v.$reset()
    }
  },
  created () {
    this.form = { ...this.form, ...this.group }
  }
}
</script>
